import { Ok, RemoteDeskInfo, User, userDisplayName } from "@/models/biz_model"
import {
  DataReport,
  LogData,
  LogExtraData,
  setReportContext,
} from "@/utils/data_report"
import { DeviceUseCase } from "./device"

// 连接级上报数据（断连时清空）；用户/企业/设备等每条固定字段见 _reportContext
let extraData: LogExtraData = {}

// 设置上报用户的信息
function setUserInfo(user: User): void {
  // 用户/设备标识等作为每条日志固定字段上报（持久，不随断连丢失）
  setReportContext({
    user: userDisplayName(user),
    username: user.account,
    local_dev_id: user.localDevId || "",
    desktop_id: user.desktopId || "",
    device_id: user.deviceId || "",
    configured_scene: user.business_scene || "",
    device_region: user.region || "",
    ...(user.accountID != null ? { company_id: String(user.accountID) } : {}),
  })
}

// 设置上报的设备信息
function setDeviceInfo({
  id,
  desktopId,
  gateWayIp,
  desktopPublicIp,
  idcId,
}: RemoteDeskInfo): void {
  // 连接级字段（断连清空）
  extraData = {
    ...extraData,
    deviceId: id == null ? "" : String(id),
    desktopId,
  }
  // 设备相关固定字段（持久；仅当非空时写入，与 android 端 null 跳过一致）
  const ctx: Partial<{
    gateway_ip: string
    desktop_public_ip: string
    idc_id: string
    desktop_id: string
    device_id: string
  }> = {}
  if (desktopId) ctx.desktop_id = desktopId
  if (id != null) ctx.device_id = String(id)
  if (gateWayIp) ctx.gateway_ip = gateWayIp
  if (desktopPublicIp) ctx.desktop_public_ip = desktopPublicIp
  if (idcId) ctx.idc_id = idcId
  if (Object.keys(ctx).length > 0) setReportContext(ctx)
}

// 设置连接 ID
function setConnectionId(id: string) {
  extraData = { ...extraData, conn_id: id }
}

/* 上报错误事件
 * @param errCode: 错误唯一标识
 * @param msg: 错误信息
 **/
function reportError(
  errCode: number,
  msg: string | undefined,
  extra?: LogExtraData
) {
  let data = { ...extraData, msg }
  if (extra) {
    data = { ...data, ...extra }
  }
  console.error("errCode:", errCode, "data:", data)
  DataReport.reportError(errCode, data)
}

async function reportLog(event: string, extra?: LogExtraData) {
  const localDevIdRes = await DeviceUseCase.getLocalDeviceId()
  if (localDevIdRes instanceof Ok) {
    setReportContext({ local_dev_id: localDevIdRes.unwrap() })
  }
  let data = { ...extraData }
  if (extra) {
    data = { ...data, ...extra }
  }
  const logData = new LogData(event, data)
  DataReport.reportLog(logData)
}

// 批量上报数据
async function reportLogs(logs: LogData[]) {
  const localDevIdRes = await DeviceUseCase.getLocalDeviceId()
  if (localDevIdRes instanceof Ok) {
    setReportContext({ local_dev_id: localDevIdRes.unwrap() })
  }
  logs = logs.map((log) => new LogData(log.event, { ...extraData, ...log.data }))
  DataReport.reportLogs(logs)
}

function onDisconnect() {
  extraData = {}
}

export const DataReportUsecase = {
  setUserInfo,
  setDeviceInfo,
  setConnectionId,
  onDisconnect,
  reportError,
  reportLog,
  reportLogs,
}
